import React, { Component } from 'react';
import Switch from '../Part_Sample/Switch';
import Off from '../../Images/Cell_Status_Icon/Power/power-gray.png';
import On from '../../Images/Cell_Status_Icon/Power/power-green.png';
import Timer_On from '../../Images/Cell_Status_Icon/Offtimer/offtimer-green.png';
import Timer_Off from '../../Images/Cell_Status_Icon/Offtimer/offtimer-gray.png';
// Hrv
import Freshup_on from '../../Images/Daikin_Images/image/AutoChangeover.png';
import Freshup_off from '../../Images/Daikin_Images/image/Back.png';

import { getFanstepIcon, getFlapIcon, getModeIcon, getVModeIcon, isEmpty } from '../Common/Common';
// Note*: Display_Action.js is used in Scenes, Schedule to display action icons for existing commands

export default class Display_Action extends Component {
	constructor(props) {
		super(props);

		this.state = {

		}
	}


	render() {
		let style = {
			display: 'inline-block',
			paddingRight: 10
		}

		style = Object.assign(style, this.props.style);

		return (
			<div style={style}>
				{Object.keys(this.props.actions).map((key) => {
					let icon = null;
					switch (key) {
						case 'stat':
							if (this.props.actions[key] == 'on') {
								return (
									<div style={{ display: 'inline-block' }}><img src={On} style={{ width: 20 }} /></div>
								)
							} else {
								return (
									<div style={{ display: 'inline-block' }}><img src={Off} style={{ width: 20 }} /></div>
								)
							}
							break;
						case 'sp':
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.actions[key] + this.props.receiver.getString('DEG')}</span></div>
							)
							break;
						case 'hum_sp':
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.actions[key] + '%'}</span></div>
							)
							break;
						case 'fanstep':
							let steps = 3;
							if (!isEmpty(this.props.point_info)) {
								steps = this.props.point_info.fanstep_cap.S != null ? this.props.point_info.fanstep_cap.S : 3;
							}
							icon = getFanstepIcon(steps, this.props.actions[key])
							return (
								<div style={{ display: 'inline-block' }}><img src={icon} style={{ width: 20 }} /></div>
							)
							break;
						case 'flap':
							let flap_steps = null;
							if (!isEmpty(this.props.point_info)) {
								flap_steps = this.props.point_info.flap_cap.D != null ? this.props.point_info.flap_cap.D : 3;
							}

							icon = getFlapIcon(flap_steps, this.props.actions[key]);
							return (
								<div style={{ display: 'inline-block' }}><img src={icon} style={{ width: 20 }} /></div>
							)
							break;
						case 'mode':
							icon = getModeIcon(this.props.actions[key]);
							return (
								<div style={{ display: 'inline-block' }}><img src={icon} style={{ width: 20 }} /></div>
							)
							break;
						case 'av':
							if (!isEmpty(this.props.point_info)) {
								return (
									<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('value') + ': ' + this.props.actions[key] + this.props.point_info.unit}</span></div>
								)
							} else {
								return (
									<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('value') + ': ' + this.props.actions[key]}</span></div>
								)
							}
							break;
						case 'off_timer':
							return (
								<div style={{ display: 'inline-block' }}><img src={this.props.actions[key] == 'on' ? Timer_On : Timer_Off} style={{ width: 20 }} /></div>
							)
							break;
						case 'sb_csp':
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('csp_sb') + ': ' + this.props.actions[key]}</span></div>
							)
							break;
						case 'sb_hsp':
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('hsp_sb') + ': ' + this.props.actions[key]}</span></div>
							)
							break;
						case 'scene':
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('scene_exec') + ': ' + this.props.actions[key]}</span></div>
							)
							break;
						case 'interlock':
							let interlock_value = this.props.actions[key] ? this.props.receiver.getString('enable') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('interlock') + ': ' + interlock_value}</span></div>
							)
							break;
						case 'notify':
							let notification_value = this.props.actions[key] ? this.props.receiver.getString('enable') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('notifications') + ': ' + notification_value}</span></div>
							)
							break;
						case 'error':
							if (this.props.actions[key] == 'true') {
								return (
									<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('error') + ': ' + this.props.receiver.getString('interlock_occur')}</span></div>
								)
							} else {
								return (
									<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('error') + ': ' + this.props.receiver.getString('clear')}</span></div>
								)
							}
							break;
						case 'exec':
							let exec_value = this.props.actions[key] ? this.props.receiver.getString('scene_exec') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{exec_value}</span></div>
							)
							break;
						case 'enable':
							let enable_value = this.props.actions[key] ? this.props.receiver.getString('enable') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('program') + ': ' + enable_value}</span></div>
							)
							break;
						case 'lock':
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('lock') + ": " + this.props.receiver.getString(this.props.actions[key])}</span></div>
							)
						case 'shutter':
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('shutter') + ": " + this.props.receiver.getString(this.props.actions[key])}</span></div>
							)
						case 'rgbw':
							//Convert decimal to hexadecimal
							let hex = this.props.actions[key].toString(16);
							let str = "";
							//Convert into proper 8 hexadecimals - add the missing 0s
							for (let i = 0; i < 8 - hex.length; i++) {
								str = "0" + str;
							}
							hex = str + hex;
							hex = "#" + hex.substring(0, hex.length - 2);
							return (
								<div style={{ display: 'inline-block', marginLeft: 2, width: 20, height: 20, background: hex }}></div>
							)
						case 'rop_proh':
							let rop_proh_enable_value = this.props.actions[key] ? this.props.receiver.getString('enable') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('rop_proh') + ": " + rop_proh_enable_value}</span></div>
							)
						case 'rmode_proh':
							let rmode_proh_enable_value = this.props.actions[key] ? this.props.receiver.getString('enable') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('rmode_proh') + ": " + rmode_proh_enable_value}</span></div>
							)
						case 'rsp_proh':
							let rsp_proh_enable_value = this.props.actions[key] ? this.props.receiver.getString('enable') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('rsp_proh') + ": " + rsp_proh_enable_value}</span></div>
							)
						case 'rfan_proh':
							let rfan_proh_enable_value = this.props.actions[key] ? this.props.receiver.getString('enable') : this.props.receiver.getString('disable');
							return (
								<div style={{ display: 'inline-block', marginLeft: 2 }}><span>{this.props.receiver.getString('rfan_proh') + ": " + rfan_proh_enable_value}</span></div>
							)
						// Hrv
						case 'vmode':
							icon = getVModeIcon(this.props.actions[key]);
							return (
								<div style={{ display: 'inline-block' }}><img src={icon} style={{ width: 20 }} /></div>
							)
							break;
						case 'vamount':
							let v_steps = 2;
							icon = getFanstepIcon(v_steps, this.props.actions[key])
							return (
								<div style={{ display: 'inline-block' }}><img src={icon} style={{ width: 20 }} /></div>
							)
							break;
						case 'freshup':
							if (this.props.actions[key] == 'on') {
								return (
									<div style={{ display: 'inline-block' }}><img src={Freshup_on} style={{ width: 20 }} /></div>
								)
							} else {
								return (
									<div style={{ display: 'inline-block' }}><img src={Freshup_off} style={{ width: 20 }} /></div>
								)
							}
							break;
						default:
							return null
					}
					return (
						<div></div>
					)
				})}
			</div>
		)
	}
}